import { useTranslation } from 'react-i18next';
import { Table } from 'antd';
import dayjs, { Dayjs } from 'dayjs';

export interface INewsLetterTableProps {
  data: any;
  selectedStartDate: any;
  selectedEndDate: any;
  selectedEstablishments: string[];
  'data-export-mode'?: string;
}

const NewsLetterTable: React.FC<INewsLetterTableProps> = ({
  data,
  selectedStartDate,
  selectedEndDate,
  selectedEstablishments,
  ...rest
}) => {
  const exportMode = rest['data-export-mode'] === 'true';
  const { t } = useTranslation('newsletter');

  const getColumns = () => {
    const columns: any[] = [
      {
        title: t('presentations'),
        dataIndex: 'product',
        key: 'product',
      },
    ];

    selectedEstablishments.forEach((establishment) => {
      if (selectedStartDate && selectedEndDate) {
        const dates: Dayjs[] = [];
        // let date = dayjs(selectedStartDate);
        // while (date.isBefore(selectedEndDate) || date.isSame(selectedEndDate)) {
        //   dates.push(date);
        //   date = date.add(1, 'day');
        // }

        const startDateConverted = dayjs(selectedStartDate);
        const endDateConverted = dayjs(selectedEndDate);
        dates.push(startDateConverted);
        dates.push(endDateConverted);

        dates.forEach((date) => {
          const formattedDate = date.format('YYYY-MM-DD');
          columns.push({
            title: `${establishment} (${formattedDate})`,
            dataIndex: `${establishment}-${formattedDate}`,
            key: `${establishment}-${formattedDate}`,
            render: (value: any, record: any) => {
              const matchingEstablishment = record?.establishment.find(
                (establishmentData: any) =>
                  establishmentData?.establishment === establishment &&
                  establishmentData.date === formattedDate
              );
              if (matchingEstablishment) {
                return (
                  <div>
                    <p>
                      {matchingEstablishment?.price !== null
                        ? `L. ${matchingEstablishment?.price}`
                        : '-'}
                    </p>
                    {/* <br /> */}
                    {matchingEstablishment?.priceFoundDate && (
                      <p className="text-sm text-gray-400">
                        {matchingEstablishment?.priceFoundDate &&
                          dayjs(new Date(Number(matchingEstablishment?.priceFoundDate))).format(
                            'YYYY-MM-DD'
                          )}
                      </p>
                    )}
                  </div>
                );
              }
              return <div>-</div>;
            },
          });
        });
      }
    });

    return columns;
  };

  const getTableData = () => {
    return data?.map((row: any) => ({
      key: row?.product,
      product: row?.product,
      establishment: row?.establishmentData,
    }));
  };

  return (
    <>
      <div className="my-6 w-full rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
        <div className="items-start">
          <h2 className="text-xl font-medium text-headings-font-color">
            {t('comparisonTableHeading')}
          </h2>
          <p className="mb-4 text-base font-medium text-font-color">
            {t('comparisonTableSubHeading', {
              startDateVal: dayjs(selectedStartDate).format('YYYY-MM-DD'),
              endDateVal: dayjs(selectedEndDate).format('YYYY-MM-DD'),
            })}
          </p>
        </div>

        <div
          className={`table-container w-full bg-white p-0 md:p-5 ${exportMode ? 'w-auto overflow-visible' : 'overflow-x-auto'} `}
          style={exportMode ? { width: 'max-content' } : undefined}
          {...rest}
        >
          {/* <Table
                dataSource={generatedTableData}
                columns={dynamicTableColumns}
                pagination={false}
              /> */}
          <Table
            dataSource={getTableData()}
            columns={getColumns()}
            pagination={false}
            scroll={exportMode ? undefined : { x: 'max-content' }}
          />
        </div>
      </div>
    </>
  );
};

export default NewsLetterTable;
